var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pagebox" }, [
    _c(
      "div",
      { staticClass: "page_head" },
      [
        _c(
          "el-select",
          {
            staticClass: "langSel",
            attrs: { placeholder: _vm.$t("m.select"), size: "small" },
            model: {
              value: _vm.thisLang,
              callback: function($$v) {
                _vm.thisLang = $$v
              },
              expression: "thisLang"
            }
          },
          _vm._l(_vm.langArrs, function(item) {
            return _c("el-option", {
              key: item.key,
              attrs: { label: item.name, value: item.key }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "maincon" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "login_box" }, [
        _vm.scanLogin == 2
          ? _c("img", {
              staticClass: "loginTypeArrow ar_img",
              attrs: { src: require("../assets/img/computer.png") },
              on: {
                click: function($event) {
                  _vm.scanLogin = 1
                  _vm.hideXieyi = false
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.scanLogin == 1
          ? _c("img", {
              staticClass: "loginTypeArrow ar_img",
              attrs: { src: require("../assets/img/scanlog.png") },
              on: {
                click: function($event) {
                  _vm.scanLogin = 2
                  _vm.hideXieyi = false
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "login_form" },
          [
            _vm.scanLogin == 2
              ? _c("scan-login", {
                  ref: "codeView",
                  attrs: { agreeXieyi: _vm.checked }
                })
              : _vm.loginType == 2
              ? _c("change-phone", {
                  attrs: { agreeXieyi: _vm.checked },
                  on: { changephone: _vm.changephone }
                })
              : _vm.loginType == 1
              ? _c("login-register-tab", {
                  attrs: { agreeXieyi: _vm.checked },
                  on: { hide: _vm.hide }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        !_vm.hideXieyi
          ? _c(
              "div",
              { staticClass: "xieyibox", class: { sm: _vm.loginType == 2 } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.checked,
                      expression: "checked"
                    }
                  ],
                  staticClass: "checkbox",
                  attrs: { type: "checkbox", id: "xieyi" },
                  domProps: {
                    checked: Array.isArray(_vm.checked)
                      ? _vm._i(_vm.checked, null) > -1
                      : _vm.checked
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.checked,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.checked = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.checked = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", {
                  staticClass: "checkboxlabel fc-pointer",
                  attrs: { for: "xieyi" }
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "fc-mar-lr-min",
                  attrs: { for: "xieyi" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("m.log_reg_agree", {
                        msg_ss:
                          "<a class='fc-color-main' href='" +
                          _vm.getH5Url() +
                          "/article/guildAgree/index.html?lang=" +
                          _vm.$store.state.localeLang +
                          "' target='_blank'>《" +
                          _vm.$t("m.community_convention") +
                          "》</a>"
                      })
                    )
                  }
                })
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "maincon_bg" }, [
      _c("img", {
        attrs: { src: require("../assets/img/login_bg.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c40149d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c40149d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = null
// module chunks = 